<template>
    <edit-string
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue || $t('email')"
        :name="name"
        :info="info"
        type="email"
    >
        <template v-if="verifyUser" #append>
            <div class="d-flex align-center">
                <app-tooltip v-if="verified" :value="$t('verified')">
                    <v-icon dense color="success">{{ getIcon('success', 'fad') }}</v-icon>
                </app-tooltip>

                <app-chip
                    v-else-if="verificationSent"
                    success
                    :text="$t('sent')"
                    :tooltip="$t('check_your_email_to_verify_your_email_address')"
                />

                <app-chip v-else-if="verificationError" error :text="$t('error')" :tooltip="verificationError" />

                <app-chip v-else-if="verifying" loading :text="$t('sending')" :tooltip="$t('please_wait')" primary />

                <app-button
                    v-else-if="inputValue"
                    :text="$t('verify')"
                    :tooltip="
                        disableVerification
                            ? $t('you_must_tick_the_can_log_in_option_to_send_another_verification_email')
                            : $t('send_verification_email')
                    "
                    :disabled="disableVerification"
                    icon="warning"
                    class="mr-n1"
                    @click="verifyUser.$verifyEmail()"
                />
            </div>
        </template>
    </edit-string>
</template>

<script>
import BaseField from './BaseField';
import User from '@/models/User';
export default {
    name: 'Email',
    extends: BaseField,
    props: {
        verifyUser: {
            type: User,
            default: null
        },
        disableVerification: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        verified() {
            if (!this.verifyUser) {
                return false;
            }

            return this.verifyUser.email_verified;
        },
        verifying() {
            if (!this.verifyUser) {
                return false;
            }

            return this.verifyUser.$verifyingEmail;
        },
        verificationError() {
            if (!this.verifyUser) {
                return false;
            }

            return this.verifyUser.$verificationEmailError;
        },
        verificationSent() {
            if (!this.verifyUser) {
                return false;
            }

            return this.verifyUser.$verificationEmailSent;
        }
    },
    mounted() {
        this.rulesArray = [v => this.getValidator('email')(v, this.labelValue || this.$t('email'))];
    }
};
</script>
